import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timestampFormat'
})
export class TimestampFormatPipe implements PipeTransform {
  transform(value: number, decimals?: number): string {
    let parsedDecimal: number = 2;
    if (typeof decimals != 'undefined' && parseInt(decimals.toString()) >= 0) {
      parsedDecimal = parseInt(decimals.toString());
    }
    if (value < 1000) {
      return `${value} ms`;
    } else if (value < 60 * 1000) {
      return `${(value / 1000).toFixed(parsedDecimal)} s`;
    } else if (value < 60 * 60 * 1000) {
      return `${(value / (60 * 1000)).toFixed(parsedDecimal)} m`;
    } else if (value < 24 * 60 * 60 * 1000) {
      return `${(value / (60 * 60 * 1000)).toFixed(parsedDecimal)} h`;
    } else {
      return `${(value / (24 * 60 * 60 * 1000)).toFixed(parsedDecimal)} d`;
    }
  }
}
